import { motion } from "framer-motion";
import { TRUST_FACTS, PROBLEMS } from "../../data/content";

const reveal = {
  hidden: { opacity: 0, y: 24 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.5, delay: i * 0.08, ease: "easeOut" } }),
};

export const TrustBar = () => (
  <section className="border-y border-[#2A303A] bg-[#171B21]" data-testid="trust-bar">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
      {TRUST_FACTS.map((f, i) => (
        <motion.div key={f.title} custom={i} variants={reveal} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-60px" }} data-testid={`trust-fact-${i}`}>
          <p className="font-display text-lg font-semibold">{f.title}</p>
          <p className="mt-2 text-sm text-[#9AA3AF] leading-relaxed">{f.text}</p>
        </motion.div>
      ))}
    </div>
  </section>
);

export const Problem = () => (
  <section className="py-24 md:py-32 px-6 md:px-12" data-testid="problem-section">
    <div className="max-w-7xl mx-auto">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, ease: "easeOut" }}>
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight max-w-3xl">
          Ihre Kunden suchen längst online. Die Frage ist nur, wen sie finden.
        </h2>
        <p className="mt-5 text-base md:text-lg text-[#9AA3AF] max-w-2xl leading-relaxed">
          Volle Auftragsbücher heute sind keine Garantie für morgen. Drei Situationen, die wir jeden Tag sehen:
        </p>
      </motion.div>
      <div className="mt-14 grid md:grid-cols-3 gap-px bg-[#2A303A] border border-[#2A303A]">
        {PROBLEMS.map((p, i) => (
          <motion.div
            key={p.title}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            className="bg-[#101318] p-8 md:p-10"
            data-testid={`problem-card-${i}`}
          >
            <span className="font-display text-sm font-bold text-[#2E5BFF]">0{i + 1}</span>
            <h3 className="font-display text-xl md:text-2xl font-semibold mt-3">{p.title}</h3>
            <p className="mt-3 text-sm md:text-base text-[#9AA3AF] leading-relaxed">{p.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
